import { menulist } from "../api/system";
import { menuList } from "../api/role";

import { info } from "../api/role";
import store from "../store";
let permission = {
  menulist: [],
  roleMenuList: [],
  path: "",
  routes: [],
  init(path, routes) {
    this.path = path;
    this.routes = routes;
    var _this = this;
    return new Promise(function(resolve, reject) {
      if (
        path == "/404" ||
        path == "/yanzhengma" ||
        path == "/getCode" ||
        path == "/sceneSelect" ||
        path == "/upgradeStatus" ||
        path == "/centerHtml"
      ) {
        resolve();
        return;
      }
      //判断是否登录
      if (!store.getters.get_token) {
        console.log("未登录");
        let code = _this.exit404() ? 404 : 110;
        resolve({ code: code });
        return;
      }
      //判断菜单是否加载
      if (store.getters.get_menu) {
        console.log("未加载");
        let code = _this.exit404() ? 404 : -1;
        resolve({ code: code });
        return;
      }

      //获取菜单接口
      // var token = JSON.parse(window.sessionStorage.getItem("token"));
      // var roleId = token.roleId;
      // _this.getPromise().then(function(d) {
      //   if (d) {
      //     let code = _this.exit404(d) ? 404 : 1;
      //     resolve({ code: code, data: d });
      //   } else {
      //     let code = _this.exit404() ? 404 : 1;
      //     resolve({ code: code });
      //   }
      // });
      menuList({ type: 1 })
        .then((d) => {
          if (d.code == 200) {
            _this.menulist = d.data;
            // console.log(1111111, d.data);
            _this.getPromise().then(function(d) {
              if (d) {
                let code = _this.exit404(d) ? 404 : 1;
                resolve({ code: code, data: d });
              } else {
                let code = _this.exit404() ? 404 : 1;
                resolve({ code: code });
              }
            });
          } else {
            this.$messges.error(d.message);
          }
        })
        .catch((e) => {
          console.log(e);
          resolve();
        });
    });
  },
  exit404(d) {
    // console.log(d);
    if (d) {
      this.routes = d.concat(this.routes);
    }
    var n404 = true;
    if (this.routes.findIndex((e) => e.path == this.path) >= 0) {
      n404 = false;
    }
    if (n404) {
      this.routes.forEach((e) => {
        if (
          e.children &&
          e.children.findIndex((c) => c.path == this.path) >= 0
        ) {
          n404 = false;
        }
      });
    }
    return n404;
  },
  getPromise() {
    var _this = this;
    return new Promise(function(resolve, reject) {
      //获取角色菜单
      // let roleList = store.getters.get_user.roleList;
      // console.log(111111, roleList);
      // console.log('菜单列表', roleList);
      var token = JSON.parse(window.sessionStorage.getItem("token"));
      console.log(token);
      var roleId = token.roleId;
      // var sceneId = window.sessionStorage.getItem("sceneId");
      var sceneId = store.getters.get_sceneId;
      console.log(store.getters.get_sceneName, "场景名称");
      var name = store.getters.get_sceneName;
      console.log(sceneId, "场景id");
      console.log(roleId, 333333);
      if (roleId != undefined && roleId != null) {
        console.log(roleId, 2222);
        setTimeout(() => {
          menulist({ roleId: roleId, serverId: 1 })
            .then((d) => {
              console.log("info", d);
              if (d.code == 200) {
                console.log(d.data, 99999999);
                // console.log(22222, d.data);
                //菜单拼装
                _this.roleMenuList = _this.pinPromise(d.data);
                console.log(_this.roleMenuList, "菜单");
                //缓存菜单
                store.dispatch("set_menu", _this.roleMenuList).then(() => {
                  resolve(_this.roleMenuList);
                });
              }
            })
            .catch((e) => {
              console.log(e);
              resolve();
            });
        }, 500);
      } else {
        resolve();
      }
    });
  },
  pinPromise(data) {
    var compare = function(obj1, obj2) {
      var val1 = obj1.sort;
      var val2 = obj2.sort;
      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    };
    console.log(data.ifMap, "data.ifMap");
    if (data.ifMap) {
      let routers = [];
      for (var key in data.ifMap) {
        console.log(key, "对象");
        var menu = data.ifMap[key].menuInfo;
        console.log(menu, "menu");
        var btns = data.ifMap[key].menuBtnList;
        // console.log(btns, "btns");
        var router = {
          sort: menu.sort,
          path: menu.url,
          menuId: menu.menuId,
          pid: menu.pid,
          meta: { btns: btns },
          name: menu.menuName,
          iconCls: menu.menuIcon, //图标样式class
          children: [],
        };
        // console.log(router)
        //{ path: '/nav1/table', component: Table, name: 'Table' }
        if (router.pid > 0) {
          var prouter = routers.find((e) => e.menuId == router.pid);
          console.log(prouter, "prouter");
          if (prouter) {
            prouter.children.push(router);
          } else {
            var pmenu = this.menulist.find((e) => e.menuId == router.pid);
            if (pmenu) {
              var prouter = {
                sort: pmenu.sort,
                path: pmenu.url,
                menuId: pmenu.menuId,
                pid: pmenu.pid,
                meta: { btns: btns },
                redirect: pmenu.url,
                name: pmenu.menuName,
                iconCls: pmenu.menuIcon, //图标样式class
                children: [router],
              };
              routers.push(prouter);
            }
          }
        } else {
          routers.push(router);
        }
      }
      routers.forEach((e) => {
        e.children = e.children.sort(compare);
      });
      console.log(routers.sort(compare), 222);
      return routers.sort(compare);
    }
    return [];
  },
};
export default permission;
